import { IPageParam } from '@core/main/types/common';

/**
 * 接口用量 - 使用记录查询参数
 */
export interface IUsageRecordParam extends IPageParam {
  /** 调用日期开始 */
  callTimeStart?: string;
  /** 调用日期结束 */
  callTimeEnd?: string;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 直属代理商 */
  agentName?: string;
  /** 使用场景 */
  usageScenario?: EuseageScenario;
  /** 特级代理商 */
  agentTopName?: string;
  /** 接口（产品）名称 */
  apiName?: string;
}

/**
 * 接口用量 - 使用记录项
 */
export interface IUsageRecordItem {
  /** 流水号 */
  code: string;
  /** 调用时间 */
  callTime: string;
  /** 企业名称 */
  companyName: string;
  /** 统一社会信用代码 */
  creditCode: string;
  /** 直属代理商 */
  agentName: string;
  /** 特级代理商 */
  agentTopName: string;
  /** 接口（产品）名称 */
  apiName: string;
  /** 使用场景 */
  usageScenario: string;
  /** 扣费详情 */
  deductDetail: string;
}

/** 接口（产品）名称 */
export enum EInterfaceName {
  IDENTITY_TWO_ELEMENTS_VERIFICATION = 'IDENTITY_TWO_ELEMENTS_VERIFICATION',
  OPERATOR_THREE_ELEMENTS_VERIFICATION = 'OPERATOR_THREE_ELEMENTS_VERIFICATION',
  BANK_THREE_ELEMENTS_VERIFICATION = 'BANK_THREE_ELEMENTS_VERIFICATION',
  BANK_FOUR_ELEMENTS_VERIFICATION = 'BANK_FOUR_ELEMENTS_VERIFICATION',
  CONTRACT_GENERATION = 'CONTRACT_GENERATION',
}

export const interfaceNameLabel = {
  [EInterfaceName.IDENTITY_TWO_ELEMENTS_VERIFICATION]: '身份二要素验证',
  [EInterfaceName.OPERATOR_THREE_ELEMENTS_VERIFICATION]: '运营商三要素验证',
  [EInterfaceName.BANK_THREE_ELEMENTS_VERIFICATION]: '银行三要素验证',
  [EInterfaceName.BANK_FOUR_ELEMENTS_VERIFICATION]: '银行四要素验证',
  [EInterfaceName.CONTRACT_GENERATION]: '合同生成',
};

/** 使用场景 */
export enum EuseageScenario {
  H5_REAL_NAME = 'H5_REAL_NAME',
  NEW_FREELANCER = 'NEW_FREELANCER',
  IMPORT_FREELANCER = 'IMPORT_FREELANCER',
  API_CONTRACT_SIGN_LINK = 'API_CONTRACT_SIGN_LINK',
  ADD_BANK_CARD = 'ADD_BANK_CARD',
  BIND_BANK_CARD = 'BIND_BANK_CARD',
  TASK_DISPATCH_TEMPLATE_FETCH = 'TASK_DISPATCH_TEMPLATE_FETCH',
  TASK_DISPATCH_TAX_CHECK = 'TASK_DISPATCH_TAX_CHECK',
  API_GET_H5_URL = 'API_GET_H5_URL',
  SUB_ACCOUNT_MINI_APP_CREATE_PAYEE = 'SUB_ACCOUNT_MINI_APP_CREATE_PAYEE',
  YEEPAY_SAVE_PAYEE = 'YEEPAY_SAVE_PAYEE',
  YEEPAY_SAVE_PAYEE_H5 = 'YEEPAY_SAVE_PAYEE_H5',
  FREE_CONTRACT = 'FREE_CONTRACT',
  TASK_CONTRACT_CROWD = 'TASK_CONTRACT_CROWD',
  TASK_SUPPLEMENT_CROWD = 'TASK_SUPPLEMENT_CROWD',
  TASK_CONTRACT_MATCH = 'TASK_CONTRACT_MATCH',
  TASK_SUB_CONTRACT_MATCH = 'TASK_SUB_CONTRACT_MATCH',
}

export const useageScenarioLabel = {
  [EuseageScenario.H5_REAL_NAME]: 'H5实名认证',
  [EuseageScenario.NEW_FREELANCER]: '新增自由职业者',
  [EuseageScenario.IMPORT_FREELANCER]: '导入自由职业者',
  [EuseageScenario.API_CONTRACT_SIGN_LINK]: 'api合同签署链接',
  [EuseageScenario.ADD_BANK_CARD]: '新增银行卡',
  [EuseageScenario.BIND_BANK_CARD]: '绑定银行卡',
  [EuseageScenario.TASK_DISPATCH_TEMPLATE_FETCH]: '任务派发-模板获取',
  [EuseageScenario.TASK_DISPATCH_TAX_CHECK]: '任务派发-计税款校验',
  [EuseageScenario.API_GET_H5_URL]: 'api获取H5地址',
  [EuseageScenario.SUB_ACCOUNT_MINI_APP_CREATE_PAYEE]: '分账小程序-创建收款方',
  [EuseageScenario.YEEPAY_SAVE_PAYEE]: '易宝支付-保存收款方',
  [EuseageScenario.YEEPAY_SAVE_PAYEE_H5]: '易宝支付-保存收款方（H5）',
  [EuseageScenario.FREE_CONTRACT]: '自由合同',
  [EuseageScenario.TASK_CONTRACT_CROWD]: '任务合同（众包）',
  [EuseageScenario.TASK_SUPPLEMENT_CROWD]: '任务补充协议（众包）',
  [EuseageScenario.TASK_CONTRACT_MATCH]: '任务合同（撮合）',
  [EuseageScenario.TASK_SUB_CONTRACT_MATCH]: '任务子合同（撮合）',
};